import React from 'react';

const baseClasses =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold tracking-tight transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-45';

const sizeClasses = {
  sm: 'h-9 px-4 text-sm',
  md: 'h-11 px-5 text-base',
  lg: 'h-12 px-7 text-base',
  xl: 'h-14 px-9 text-lg',
};

export const createButton = (styleClasses, displayName = 'Button') => {
  const ButtonComponent = ({
    as: Component = 'button',
    size = 'md',
    fullWidth = false,
    className = '',
    children,
    type = 'button',
    ...props
  }) => {
    const classes = [
      baseClasses,
      sizeClasses[size] || sizeClasses.md,
      fullWidth ? 'w-full' : '',
      styleClasses,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    const sharedProps = {
      className: classes,
      ...props,
    };

    if (Component === 'button') {
      return (
        <button type={type} {...sharedProps}>
          {children}
        </button>
      );
    }

    const { type: _ignoredType, ...restProps } = sharedProps;
    return <Component {...restProps}>{children}</Component>;
  };

  ButtonComponent.displayName = displayName;
  return ButtonComponent;
};

export default createButton;
